<template>
    <div class="pNavigation">
        <BetButton :to="prevPost.link" text="< Anterior" v-if="prevPost" :mode="mode" />
        <BetButton :to="nextPost.link" text="Próximo >" v-if="nextPost" :mode="mode" />
    </div>
</template>

<script>
import BetButton from '@/components/BetButton.vue'
import axios from '@/load_axios'
import { API_HOST } from '@/constants'
const postURL = `${API_HOST}/wp-json/blat/v1/post`

export default {
    name: 'PostNavigation',
    components: {
        BetButton,
    },
    props: {
        post: { required: true },
        mode: { default: 'normal' },
    },
    data() {
        return {
            nextPrevPosts: null,
        }
    },
    computed: {
        nextPost() {
            if (this.nextPrevPosts == null) {
                return null
            }
            return this.nextPrevPosts.next
        },
        prevPost() {
            if (this.nextPrevPosts == null) {
                return null
            }
            return this.nextPrevPosts.previous
        },
    },
    watch: {
        post: {
            immediate: true,
            async handler() {
                if (this.post == null) {
                    return
                }
                let res = await axios.get(postURL, { params: { id: this.post.id } })
                this.nextPrevPosts = res.data
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.pNavigation {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: calc(var(--content-width) * .03);
}
</style>
